import { Component, type ErrorInfo, type PropsWithChildren } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { OperatorGate } from "./auth/operator-gate";
import { Button, Notice } from "./components/ui";
import { describeOperatorError } from "./lib/errors";
import { CreateOrganisationRoute } from "./organisations/create";
import { OrganisationsListRoute } from "./organisations/list";

type ErrorBoundaryState = { error: unknown | null };

class RouteErrorBoundary extends Component<PropsWithChildren, ErrorBoundaryState> {
  state: ErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: unknown): ErrorBoundaryState {
    return { error };
  }

  componentDidCatch(_error: unknown, _info: ErrorInfo) {
    // Convex already reports query failures. Keep customer data out of browser logs.
  }

  render() {
    if (this.state.error) {
      return (
        <div className="route-error">
          <p className="eyebrow">Register unavailable</p>
          <h1>Organisations could not be loaded</h1>
          <Notice tone="danger">{describeOperatorError(this.state.error, "load")}</Notice>
          <Button onClick={() => window.location.reload()}>Try again</Button>
        </div>
      );
    }
    return this.props.children;
  }
}

export function App() {
  return (
    <OperatorGate>
      <RouteErrorBoundary>
        <Routes>
          <Route index element={<OrganisationsListRoute />} />
          <Route path="organisations/new" element={<CreateOrganisationRoute />} />
          <Route path="*" element={<Navigate replace to="/" />} />
        </Routes>
      </RouteErrorBoundary>
    </OperatorGate>
  );
}
